/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-02-05 11:31:17
 * @LastEditTime: 2025-04-07 17:46:58
 * @LastEditors: ywj@originqc.com
 */
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import moreIcon from './imgs/more.svg'
import moreactive from './imgs/moreActive.svg'
import './index.scss';
interface IData { 
  data?:any
}
const GoMore: React.FC<IData> = (props) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();
  const { data } = props;

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleGoSearch = () => {
    window.open(`/shop/search?categoryId=${data.id}&parentName=${data.name}`)
  }
  return (
    <div
      className='more-box'
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleGoSearch}
    >
      <span>查看更多 <img src={isHovered ? moreactive : moreIcon} alt='more'/></span>
    </div>
  )
}

export default GoMore;